import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


import {BaseHttpService} from './ecv-http-services/base.service';
import {SessionService} from './ecv-http-services/session.service';

import {Role} from '../enums/role.enum';
import {NavigationCancel, Router} from '@angular/router';

@Injectable()
export class AuthService extends BaseHttpService {

  public static loginUrl = 'uaa/oauth/token';
  public static loginWithCrmTokenUrl = 'api/users/authorize_with_crm';
  public static loginWithUserTokenUrl = 'api/users/authorize_with_user_token';

  constructor(public sessionService: SessionService, httpClient: HttpClient, private router: Router) {
    super(httpClient, sessionService);
  }

  logIn(email: string, password: string) {
    const body = new FormData();
    body.append('username', email);
    body.append('password', password);
    body.append('grant_type', 'password');

    return this.httpClient.post(this.buildUrl(AuthService.loginUrl), body);
  }

  logInWithCrmToken(token: string) {
    return this.httpClient.post(this.buildUrl(AuthService.loginWithCrmTokenUrl), token);
  }

  loginWithUserToken(token: string) {
    return this.httpClient.get(this.buildUrl(AuthService.loginWithUserTokenUrl + '?token=' + token));
  }

  logOut() {
    this.sessionService.clear();
    localStorage.removeItem('userFirstName');
    localStorage.removeItem('userLastName');
  }

  refreshAccessToken() {
    const body = new FormData();
    body.append('refresh_token', this.sessionService.getRefreshToken());
    body.append('grant_type', 'refresh_token');

    return this.httpClient.post(this.buildUrl(AuthService.loginUrl), body);
  }

  public isAuthenticated() {
    return this.sessionService.getAccessToken() != null;
  }

  public isPractitioner() {
    return this.sessionService.getRoles().indexOf(Role[Role.PRACTITIONER]) > -1;
  }

  public isCoordinator() {
    return this.sessionService.getRoles().indexOf(Role[Role.COORDINATOR]) > -1;
  }

  public isSpecialist() {
    return this.sessionService.getRoles().indexOf(Role[Role.SPECIALIST]) > -1;
  }

  public isClient() {
    return this.sessionService.getRoles().indexOf(Role[Role.CLIENT]) > -1;
  }

  public isAdmin() {
    return this.sessionService.getRoles().indexOf(Role[Role.ADMIN]) > -1;
  }

  public setRedirectUrl() {
    let eventSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationCancel) {
        localStorage.setItem('redirect_url', event.url);
        eventSubscription.unsubscribe();
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/auth.service.ts